module.exports = __webpack_public_path__ + "img/_MG_3712.0cdc8ff0.jpg";